import { CoreInputView } from '@core/widgets';
import React, { useId } from 'react';
import { TextCommon } from '../../UI/Text/TextCommon';
import styles from '../Calculator.module.css';
import { getClearValue, getFormattedValue } from '../utils/format/format';
import { THandleUpdateValue } from '../utils/types';

type TInputCalculatorProps = {
    label?: string;
    name: string;
    value: string;
    isError?: boolean;
    isFrom?: boolean;
    handleUpdateValue: THandleUpdateValue;
    fontSize: string;
    subComponent: React.ReactNode;
    tabIndex?: number;
};

const CalculatorInput = React.memo(({ label, isError, value, handleUpdateValue, tabIndex, subComponent, name, isFrom, fontSize }: TInputCalculatorProps) => {
    const inputId = useId();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const clearValue = getClearValue(e?.target.value, value);
        handleUpdateValue(clearValue, e.target.name, isFrom);
    };
    return (
        <div className={styles.calculatorAmountBlock}>
            <TextCommon isWidget={false} content={label} options={{ variant: 'secondary', textColor: 'grey_72_lc', margin: { bottom: 4 } }} />
            <div className={styles.calculatorInputWrapper}>
                <CoreInputView
                    styleProps={{
                        font: 'var(--font-display1)',
                        outline: 'transparent',
                        padding: { top: 0, right: 0, bottom: 0, left: 0 },
                        textAlign: 'center',
                        height: 48,
                        error: 'var(--color-pink_100)',
                        fontStyle: { fontSize: parseInt(fontSize) || 40, fontSizeXl: 48, lineHeightXl: 64 },
                        hovered: {
                            onSurface: 'var(--color-purple_100)',
                        },
                    }}
                    dataTest={`calculator_input_${isFrom ?? ''}`}
                    id={inputId}
                    name={name}
                    value={getFormattedValue(value)}
                    autoComplete="off"
                    onChange={handleChange}
                    type="text"
                    inputMode="decimal"
                    tabIndex={tabIndex}
                    isError={isError}
                />
            </div>
            {subComponent}
        </div>
    );
});
export { CalculatorInput };
